import React from 'react';
import Card from './Card';
import CardHeader from './CardHeader';
import CardContent from './CardContent';

export interface ContentCardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  headerBorder?: boolean;
  loading?: boolean;
  maxHeight?: string;
  scrollable?: boolean;
  onClick?: () => void;
  className?: string;
}

const ContentCard: React.FC<ContentCardProps> = ({
  title,
  subtitle,
  children,
  actions,
  headerBorder = false,
  loading = false,
  maxHeight,
  scrollable = false,
  onClick,
  className = '',
}) => {
  return (
    <Card
      variant="content"
      size="md"
      hover={true}
      clickable={!!onClick}
      loading={loading}
      onClick={onClick}
      className={className}
    >
      {(title || subtitle || actions) && (
        <CardHeader title={title} subtitle={subtitle} actions={actions} border={headerBorder} />
      )}

      <CardContent scroll={scrollable} maxHeight={maxHeight}>
        {children}
      </CardContent>
    </Card>
  );
};

export default ContentCard;
